import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 14 Mar 2026 2:15 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.iV1mbp-4iQ2K5CSmpaezh-mMFadOlK4zU9Ibxg91YSxiqBr4rx2M8-4lEgwNNAg3VXFJy6jyLelfrCs8Pt7szA_atVzunYQoUJtaWxYfD-NAD2cAyikVlqwwqYEcrFeMy4gE2hLU0G4gKpESD-N6INfcztN7FNss0KIJgNogYV9FuGYxDeAKb7B05cjk1JH6mAL0VB7iFgsykNBQivRo8RFLTK5mX5d7wbODLPs_cCtQsq_G_Z4kYD3xFOOe0DtnWOPNjoOsVXGpAV1RsHvH5efXuHMWYUGBF1j6dmKF0PRJ0yW2MTxjdxeIFP5LyrtuOrFF0P4bcxZn6WcXUKj88WOB-weaTB34Rw",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-21T01:15:06.886395Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-14T01:14:58+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.iV1mbp-4iQ2K5CSmpaezh-mMFadOlK4zU9Ibxg91YSxiqBr4rx2M8-4lEgwNNAg3VXFJy6jyLelfrCs8Pt7szA_atVzunYQoUJtaWxYfD-NAD2cAyikVlqwwqYEcrFeMy4gE2hLU0G4gKpESD-N6INfcztN7FNss0KIJgNogYV9FuGYxDeAKb7B05cjk1JH6mAL0VB7iFgsykNBQivRo8RFLTK5mX5d7wbODLPs_cCtQsq_G_Z4kYD3xFOOe0DtnWOPNjoOsVXGpAV1RsHvH5efXuHMWYUGBF1j6dmKF0PRJ0yW2MTxjdxeIFP5LyrtuOrFF0P4bcxZn6WcXUKj88WOB-weaTB34Rw'

// {
//   "access_token": "v2.local.qssH7cgow923o9Ht7udkeUw9Rntg6ojXRkB7s2gW7bU-9kQAN7449uzFGvs0qnbukUgK0PwS8zYG9KVY2fCdjn-zxufSXao8wi-S_kRRYEI1H-NA3nU-Y0KVMyvmBHae6Et9jYGIbP8rxjhXxNJHmKWtXJh1r9ndBErUzIDpi3gwlPPIvKUOkKslDlaKYwaIzzSak8TZqphRzKEBf05jfF75bu1SyFM30QdJYDWWeOqPSU-WCbz1aYVmmHr2jG9yawNh2HZtK6O6gzCN_EM4Y7ktKqoj_oKMiLg5Mwh_cWHfiEJSJuJFVJsnkz2n-J__nUw74Q6QYVybNFlvHCciy8g_DqF1",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-21T01:16:40.871639Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-14T01:16:37+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.qssH7cgow923o9Ht7udkeUw9Rntg6ojXRkB7s2gW7bU-9kQAN7449uzFGvs0qnbukUgK0PwS8zYG9KVY2fCdjn-zxufSXao8wi-S_kRRYEI1H-NA3nU-Y0KVMyvmBHae6Et9jYGIbP8rxjhXxNJHmKWtXJh1r9ndBErUzIDpi3gwlPPIvKUOkKslDlaKYwaIzzSak8TZqphRzKEBf05jfF75bu1SyFM30QdJYDWWeOqPSU-WCbz1aYVmmHr2jG9yawNh2HZtK6O6gzCN_EM4Y7ktKqoj_oKMiLg5Mwh_cWHfiEJSJuJFVJsnkz2n-J__nUw74Q6QYVybNFlvHCciy8g_DqF1'

// {
//   "access_token": "v2.local.FWG5GCrmerqxMzB_LsnWsbR-rYAwQj168D5kPLAMdJ5gh4gSCZ83uyyLVav9oNf4cIuyAyq_ai1qXjPfj9AR0UfK1bsCVadJ4atJtrv2O24gQ5XgMHqwtChus-X0SC1jvwee6qFcpMg5_Kh_jfaREA1iUPZylNhU7inwqOSJIKjkMRN89YRBmEkMCI2sB7aZ3SuJ_6MZuOcUYtmqz9zueQV0RzSvJfg3nUGIE2Bp5G2oJpAO1jsJGx31sdwikR1iecg9IXFAfGVitRbRYBIl9EPvCcJPL-reHNtjlt1XAD_PiPwOi6JDjA8m5rgB0w-owwhaY4YocSe1gMVLOIGC6YsbTOY",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-21T01:17:56.590320Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.FWG5GCrmerqxMzB_LsnWsbR-rYAwQj168D5kPLAMdJ5gh4gSCZ83uyyLVav9oNf4cIuyAyq_ai1qXjPfj9AR0UfK1bsCVadJ4atJtrv2O24gQ5XgMHqwtChus-X0SC1jvwee6qFcpMg5_Kh_jfaREA1iUPZylNhU7inwqOSJIKjkMRN89YRBmEkMCI2sB7aZ3SuJ_6MZuOcUYtmqz9zueQV0RzSvJfg3nUGIE2Bp5G2oJpAO1jsJGx31sdwikR1iecg9IXFAfGVitRbRYBIl9EPvCcJPL-reHNtjlt1XAD_PiPwOi6JDjA8m5rgB0w-owwhaY4YocSe1gMVLOIGC6YsbTOY'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
